import React, { useEffect, useState } from 'react';
import GraphTable from '../../../Components/Common/graphTable/GraphTable';
import ApiService from "../../../utils/fetch";
import Tooltip from '@mui/material/Tooltip';
import Skeleton from '@mui/material/Skeleton';

// Tooltip cell renderer for all columns
const tooltipCellRenderer = (params) => (
  <Tooltip title={params.value ?? ''} arrow>
    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
      {params.value}
    </span>
  </Tooltip>
);

// Cell renderer to append % for percentage columns
const percentCellRenderer = (params) => (
  <Tooltip title={params.value !== undefined && params.value !== null && params.value !== "" ? `${params.value} %` : ""} arrow>
    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
      {params.value !== undefined && params.value !== null && params.value !== "" ? `${params.value} %` : ""}
    </span>
  </Tooltip>
);

// Table columns for summary percentages (Plant)
const plantTableColumns = [
  { headerName: "Plant", field: "plantDisplay", minWidth: 280, flex: 2, resizable: true, cellRenderer: tooltipCellRenderer , pinned : 'left' , filter : 'agSetColumnFilter' },
  { headerName: "Fiscal Month", field: "fiscalMonth", minWidth: 120, flex: 1, resizable: true, cellRenderer: tooltipCellRenderer , hide: true },
  { headerName: "Success %", field: "successPercent", minWidth: 120, flex: 1, resizable: true, cellStyle: { textAlign: 'center' }, cellRenderer: percentCellRenderer },
  { headerName: "Pending %", field: "pendingPercent", minWidth: 120, flex: 1, resizable: true, cellStyle: { textAlign: 'center' }, cellRenderer: percentCellRenderer },
  { headerName: "Error %", field: "errorPercent", minWidth: 120, flex: 1, resizable: true, cellStyle: { textAlign: 'center' }, cellRenderer: percentCellRenderer },
  { headerName: "Variance %", field: "variancePercent", minWidth: 120, flex: 1, resizable: true, cellStyle: { textAlign: 'center' }, cellRenderer: percentCellRenderer, hide: true }
];

const PlantTable = ({ fiscalMonths, forecastTerm, gridOptions }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('PlantTable fiscalMonths:', fiscalMonths, 'forecastTerm:', forecastTerm);
    if (!fiscalMonths || fiscalMonths.length === 0 || !forecastTerm) {
      setRows([]);
      return;
    }
    setLoading(true);
    ApiService.post('/v1/metrics/get-forecast-percantage-metrics', {
      aggregateLevel: "plant",
      fiscalMonths,
      forecastTerm
    })
      .then(res => {
        // Check if response is an array or has a metrics property
        let data = Array.isArray(res.data) ? res.data : res.data?.metrics;
        if (!Array.isArray(data)) {
          setRows([]);
          return;
        }
        // Map response to required fields and format plantDisplay
        const mappedRows = data.map(item => ({
          plantDisplay: `${item.plantId || ''} - ${item.plantDesc || ''} - ${item.plantCountryDesc || ''}`,
          fiscalMonth: item.fiscalMonth,
          errorPercent: item.errorPercent,
          successPercent: item.successPercent,
          pendingPercent: item.pendingPercent,
        }));
        setRows(mappedRows);
      })
      .catch((err) => {
        setRows([]);
      })
      .finally(() => setLoading(false));
  }, [fiscalMonths, forecastTerm]);

  // Log rows whenever they change
  useEffect(() => {
    console.log('Rows state updated:', rows);
  }, [rows]);

  return (
    <>
      {loading ? (
        <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 2, mb: 2 }} />
      ) : (
        <GraphTable
          columns={plantTableColumns}
          rows={rows}
          height={'50vh'}
          tablewidth={'100%'}
          pagination={false}
          suppressPaginationPanel={true}
          suppressMovableColumns={true}
          suppressHorizontalScroll={false}
          enableBrowserTooltips={true}
          defaultColDef={{ resizable: true , sortable: true}}
          gridOptions={gridOptions}
          loading={loading}
        />
      )}
    </>
  );
};

export default PlantTable;

